module.exports = __webpack_public_path__ + "static/media/icon-moduleE4.b2f1dd03.png";